<template>
  <!-- 底部导航 -->
  <div id="tabbar">
    <div v-if="$route.path === '/newFiles' || $route.path === '/newFilesD' && currentType == 1">
      <van-tabbar v-model="active" @change="change" :border="false">
        <van-tabbar-item>
          <div class="swipe-item">
            <van-image width="18" height="20" :src="activeRole==0 ? icon.active : icon.inactive" />
          </div>
          <span :class="activeRole == 0 ? 'checked-font': ''">法规分类</span>
        </van-tabbar-item>
        <van-tabbar-item style="display:none">
          <div class="swipe-item">
            <van-image width="19" height="20" :src="activeRole==1 ? icon1.active : icon1.inactive" />
          </div>
          <span :class="activeRole==1 ? 'checked-font': ''">法规层级</span>
        </van-tabbar-item>

        <van-tabbar-item>
          
          <div class="swipe-item">
            <van-image width="26" height="20" :src="activeRole==2 ? icon2.active : icon2.inactive" />
          </div>
          <span :class="activeRole == 2 ? 'checked-font': ''">一键上传</span>
        </van-tabbar-item>
        <van-tabbar-item>
         
          <div class="swipe-item">
            <van-image width="21" height="20" :src="activeRole==3 && flag1 ? icon3.active : icon3.inactive" />
          </div>
           <span :class="activeRole == 3 &&!upSuccess ? 'checked-font': ''">
            {{ this.$store.state.choose.chooseUp1 }}
          </span>
        </van-tabbar-item>
      </van-tabbar>
    </div>
    <div
      v-if="
        $route.path === '/searchEngine' ||
          $route.path === '/searchEngineD' ||
          $route.path === '/newSearchEngine' && currentType == 1
      "
    >
      <van-tabbar v-model="active" @change="change" :border="false">
        <van-tabbar-item >
          <div class="swipe-item">
            <van-image width="18" height="20" :src="activeRole==0 ? icon.active : icon.inactive" />
          </div>
          <span :class="activeRole == 0 ? 'checked-font': ''">法规分类</span>
        </van-tabbar-item>
        <van-tabbar-item>
          <div class="swipe-item">
            <van-image width="19" height="20" :src="activeRole==1 ? icon1.active : icon1.inactive" />
          </div>
          <span :class="activeRole==1 ? 'checked-font': ''">法规层级</span>
        </van-tabbar-item>
        <van-tabbar-item>
          <div class="swipe-item">
            <van-image width="26" height="20" :src="activeRole==2 ? icon2.active : icon2.inactive" />
          </div>
          <span :class="activeRole == 2 ? 'checked-font': ''">一键上传</span>

        </van-tabbar-item>
        <van-tabbar-item>
          <!-- <span :class="active == 3 ? 'checked-font': ''">
            {{ this.$store.state.choose.chooseUp2 }}</span>
          <template #icon="props">
            <img :src="props.active && flag2 ? icon3.active : icon3.inactive" />
          </template> -->
          <div class="swipe-item">
            <van-image width="21" height="20" :src="activeRole==3 && flag1 ? icon3.active : icon3.inactive" />
          </div>
           <span :class="activeRole == 3&& !upSuccess ? 'checked-font': ''">
            {{ this.$store.state.choose.chooseUp2 }}
          </span>
        </van-tabbar-item>
      </van-tabbar>
    </div>
    <div v-if="$route.path === '/smartcloud' && currentType !== 2">
      <van-tabbar v-model="active" @change="change" :border="false">
        <van-tabbar-item >
          <div class="swipe-item">
            <van-image width="18" height="20" :src="activeRole==0 ? icon.active : icon.inactive" />
          </div>
          <span :class="activeRole == 0 ? 'checked-font': ''">法规分类</span>
        </van-tabbar-item>
        <van-tabbar-item>
          <div class="swipe-item">
            <van-image width="19" height="20" :src="activeRole==1 ? icon1.active : icon1.inactive" />
          </div>
          <span :class="activeRole==1 ? 'checked-font': ''">法规层级</span>
        </van-tabbar-item>
        <van-tabbar-item>
          <div class="swipe-item">
            <van-image width="19" height="20" :src="activeRole==2 ? icon4.active : icon4.inactive" />
          </div>
          <span :class="activeRole==2 ? 'checked-font': ''">一键删除</span>
        </van-tabbar-item>

        <van-tabbar-item>
          <div class="swipe-item">
            <van-image width="20" height="20" :src="activeRole==3 && flag3 ? icon5.active : icon5.inactive" />
          </div>
          <span :class="activeRole==3 && !delSuccess ? 'checked-font': ''">{{ this.$store.state.choose.delWord }}</span>
        </van-tabbar-item>
      </van-tabbar>
    </div>
    <div v-if="currentType == 2">
      <van-tabbar v-model="active" @change="change" :border="false">
        <van-tabbar-item>
        </van-tabbar-item>
        <van-tabbar-item>
          <span>发布层级</span>
          <template #icon="props">
            <img :src="props.active ? icon1.active : icon1.inactive" />
          </template>
        </van-tabbar-item>
        <van-tabbar-item>
        </van-tabbar-item>
      </van-tabbar>
    </div>
    <div v-if="this.$route.path == '/exclusiveInfo'">
      <van-tabbar v-model="active" @change="change" :border="false">
        <van-tabbar-item>
        </van-tabbar-item>
        <van-tabbar-item>
          <span>法规层级</span>
          <template #icon="props">
            <img :src="props.active ? icon1.active : icon1.inactive" />
          </template>
        </van-tabbar-item>
        <van-tabbar-item>
        </van-tabbar-item>
      </van-tabbar>
    </div>
    <login ref="alertModel"></login>
  </div>
</template>

<script>
import Login from "@/components/common/login";
export default {
  props: ["currentType", "delSuccess", "upSuccess"],
  components: {
    Login,
  },
  computed: {
    flag1() {
      return this.$store.state.choose.flag1;
    },
    flag2() {
      return this.$store.state.choose.flag2;
    },
    flag3() {
      return this.$store.state.choose.flag3;
    },
    lists() {
      return this.$store.state.choose.lists;
    },
    permission() {
      return this.$store.state.user.permission;
    },
    userId() {
      return this.$store.state.user.userId;
    },
    warningLevel() {
      return this.$store.state.search.warningLevel;
    },
    warningText() {
      return this.$store.state.search.warningText;
    },
  },
  data() {
    return {
      active: -1,
      icon: {
        active: require("../../../assets/index/active_tab3.png"),
        inactive: require("../../../assets/index/tab3.png"),
      },
      icon1: {
        active: require("../../../assets/index/active_tab4.png"),
        inactive: require("../../../assets/index/tab4.png"),
      },
      icon2: {
        active: require("../../../assets/index/active_tab1.png"),
        inactive: require("../../../assets/index/tab1.png"),
      },
      icon3: {
        active: require("../../../assets/index/active_tab2.png"),
        inactive: require("../../../assets/index/tab2.png"),
      },
      icon4: {
        active: require("../../../assets/index/delete.png"),
        inactive: require("../../../assets/index/un_delete.png"),
      },
      icon5: {
        active: require("../../../assets/index/cdelete.png"),
        inactive: require("../../../assets/index/un_cdelete.png"),
      },
      activeRole: -1
    };
  },
  methods: {
    change(activeitem) {
      this.active = -1;
      console.log("active==>", activeitem);
      //this.active = activeitem
      this.activeRole = activeitem
      if (activeitem === 0) {
        this.$emit("alertBars");
      } else if (activeitem === 1) {
        this.$emit("alertCengji");
      } else {
        console.log(this.warningLevel);
        if (this.$route.path == "/smartcloud") {
          if (activeitem === 2) {
            this.$emit("updateOrDelete");
          } else if (activeitem === 3) {
            this.$emit("chooseUpdateOrDelete");
          }
        } else {
          switch (this.warningLevel) {
            case 1:
              this.$refs.alertModel.changeShowLogin(true);
              this.$notify({
                message: "请先登录",
                type: "warning",
                duration: 5000,
              });
              break;
            case 2:
              this.$dialog
                .confirm({
                  title: "提示",
                  message: this.warningText,
                  confirmButtonText: "在线商城",
                  cancelButtonText: "取消",
                })
                .then(() => {
                  this.$router.push("/onlineMall");
                })
                .catch((err) => {
                  console.log(err);
                });
              break;
            case 3:
              this.$dialog
                .confirm({
                  title: "提示",
                  message: this.warningText,
                  confirmButtonText: "在线商城",
                  cancelButtonText: "取消",
                })
                .then(() => {
                  this.$router.push("/onlineMall?warninglevel=3");
                })
                .catch((err) => {
                  console.log(err);
                });
              break;
            default:
              // 000009 一键上传
              if (activeitem === 2) {
                let reqBody = {
                  funccode: "000009",
                  funcname: "一键上传",
                };
                this.$http
                  .reqCheckPremission(reqBody)
                  .then((res) => {
                    console.log(res);

                    if (res.result.protect) {
                      switch (res.result.warninglevel) {
                        case 1:
                          this.$refs.alertModel.changeShowLogin(true);
                          this.$notify({
                            message: "请先登录",
                            type: "warning",
                            duration: 5000,
                          });
                          break;
                        case 2:
                          this.$dialog
                            .confirm({
                              title: "提示",
                              message: res.result.warningtext,
                              confirmButtonText: "在线商城",
                              cancelButtonText: "取消",
                            })
                            .then(() => {
                              this.$router.push("/onlineMall");
                            })
                            .catch((err) => {
                              console.log(err);
                            });
                          break;
                        case 3:
                          this.$dialog
                            .confirm({
                              title: "提示",
                              message: res.result.warningtext,
                              confirmButtonText: "在线商城",
                              cancelButtonText: "取消",
                            })
                            .then(() => {
                              this.$router.push("/onlineMall?warninglevel=3");
                            })
                            .catch((err) => {
                              console.log(err);
                            });
                          break;
                        default:
                          break;
                      }
                    } else {
                      console.log("5xx");
                      this.$emit("updateOrDelete");
                    }
                  })
                  .catch((err) => {
                    console.log("一键上传", err);
                  });
              } else if (activeitem === 3) {
                if (this.userId) {
                  this.$emit("chooseUpdateOrDelete");
                   this.$store.commit("choose/setChooseUp2", "确定");
                } else {
                  this.$notify({
                    message: "请先登录",
                    type: "warning",
                  });
                  this.$refs.alertModel.changeShowLogin(true); // 弹出登录框
                }
              }

              break;
          }
        }
      }
    },
    // 提示弹框
    showMsgDialog(showmsg) {
      this.$dialog
        .confirm({
          title: "提示",
          message: showmsg,
          confirmButtonText: "在线商城",
          cancelButtonText: "关闭",
        })
        .then(() => {
          if (this.$store.state.user.permissionArray.includes("900001")) {
            this.$router.push("onlineMall");
          }
        })
        .catch(() => {
          this.$router.push("/newFiles");
          // 取消
        });
    },
  },
};
</script>

<style lang="less" scoped>
#tabbar {
  .van-tabbar-item {
    .checked-font {
      color: #0084FF;
    }
  }
  
  /deep/.van-tabbar-item {
    span {
      color: #999999;
    }
  }
  .swipe-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-bottom: 5px;
    img {
      width: 20px;
      height: 20px;
    }
  }
}
</style>
